<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
        :active.sync="loadingPromos"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>
    <b-container fluid="" v-if="blnDatosEmergente">
      <b-row>
        <b-col>
          <b-table-simple hover responsive sticky-header id="tabla_paciente">
            <b-thead>
              <b-tr>
                <b-th>Fecha</b-th>
                <b-th>Doctor</b-th>
                <b-th>ID de Paciente</b-th>
                <b-th>Nombre del Paciente</b-th>
              </b-tr>
            </b-thead>
            <b-tbody v-if="!blnLoaderTable">
              <tr>
                <td>{{fechaHoy}}</td>
                <td>{{nombreDoctor}}</td>
                <td>{{detallePaciente.idPaciente}}</td>
                <td>{{detallePaciente.nombrePaciente}}</td>
              </tr>
            </b-tbody>
          </b-table-simple>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div align="center" v-if="blnLoaderTable">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col><p><br></p></b-col>
      </b-row>
      <b-row v-if="selectedZona === 1">
        <div class="centerDiv col-12">
          <div class="flxButons">
            <b-form-radio v-model="adultoNino" value="1"
            >Adulto
            </b-form-radio
            >
            <b-form-radio v-model="adultoNino" value="2">Niño</b-form-radio>
            <b-form-radio v-model="adultoNino" value="3">Mixto</b-form-radio>
          </div>
        </div>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label for="zona">Zona:</label>
          <b-form-select id="zona" v-model="buscarZona" :options="lstZona" v-on:change="seleccinarZona($event)" v-if="$localStorageService.can('RE_05_elegir_razones')"></b-form-select>
        </b-col>
        <b-col cols="8">
          <b-row  v-if="selectedZona === 1">
            <b-col cols="6">
              <label>Del OD:</label>
              <b-form-select
                  v-model="oDInicio"
                  :options="dientesAdultoArray"
                  v-if="adultoNino === '1'"
              ></b-form-select>
              <b-form-select
                  v-model="oDInicio"
                  :options="dientesNinoArray"
                  v-else-if="adultoNino === '2'"
              ></b-form-select>
              <b-form-select
                  v-model="oDInicio"
                  :options="dientesMixArray"
                  v-else
              ></b-form-select>
            </b-col>
            <b-col cols="6">
              <label>Al OD:</label>
              <b-form-select
                  v-model="oD2Final"
                  :options="dientesAdultoArray"
                  v-if="adultoNino === '1'"
              ></b-form-select>
              <b-form-select
                  v-model="oD2Final"
                  :options="dientesNinoArray"
                  v-else-if="adultoNino === '2'"
              ></b-form-select>
              <b-form-select
                  v-model="oD2Final"
                  :options="dientesMixArray"
                  v-else
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row v-if="selectedZona === 2">
            <b-col>
              <label>Cuadrante:</label>
              <b-form-select id="cuadrante" v-model="cuadrante" :options="lstCuadrante" v-on:change="seleccionarCuadrante($event)"></b-form-select>
            </b-col>
          </b-row>
          <b-row v-if="selectedZona === 3">
            <b-col>
              <label>Arcada:</label>
              <b-form-select id="cuadrante" v-model="arcada" :options="lstArcada" v-on:change="seleccionarArcada($event)"></b-form-select>
            </b-col>
          </b-row>
          <b-row v-if="selectedZona === 4">
            <b-col>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row><b-col><p><br></p></b-col></b-row>
      <b-row>
        <b-col cols="4" align="right">
          <label for="padecimientos">Padecimiento:</label>
        </b-col>
        <b-col cols="8">
          <v-select label="descripcion" id="padecimientos" v-model="buscarPadecimiento" :options="lstPadecimientos" @input="seleccinarPadecimiento($event)">
            <span slot="no-options">No hay datos</span>
          </v-select>
        </b-col>
      </b-row>
      <b-row><b-col><p></p></b-col></b-row>
      <b-row v-for="(tratamiento, index) in tratamientos" :key="index">
        <b-col cols="4" align="right">
          <label :for="'tratamientos_' + index + 1">Tratamiento {{index + 1}}: </label>
        </b-col>
        <b-col cols="4">
          <v-select label="nombre" :id="'tratamientos_' + index + 1" v-model="tratamiento.nombre" :options="lstTratamientos" @input="seleccinarTratamientos($event, index)">
            <span slot="no-options">No hay datos</span>
          </v-select>
        </b-col>
        <b-col cols="4">
          <b-spinner v-if="loaderConsultarTxDescuento" class="mr-2" small label="Loading..." variant="primary"></b-spinner>
          <b-button-group>
            <b-button v-if="(index + 1) === tamanio" variant="outline-info" v-on:click="agregarTratamiento" ><em class="add_list_svg"></em></b-button>
            <b-button variant="outline-danger" v-on:click="quitarTratamiento(index)"><em class="fa fa-minus"></em></b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <b-row><b-col><p></p></b-col></b-row>
      <b-row>
        <b-col align="right">
          <b-button :disabled="loaderConsultarTxDescuento" variant="outline-success" v-on:click="Agregar()">Agregar</b-button>
          <b-button variant="outline-warning" v-on:click="Limpiar()">Limpiar</b-button>
        </b-col>
      </b-row>
      <b-row><b-col><p><br></p></b-col></b-row>
      <b-row>
        <b-col>
          <b-table-simple responsive sticky-header bordered id="tabla_resumen">
            <b-thead>
              <b-tr>
                <b-th>O.D/Zona</b-th>
                <b-th>Padecimiento</b-th>
                <b-th>Tratamiento</b-th>
                <b-th>Cantidad</b-th>
                <b-th>Acción</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <tr v-for="(diente, index) of lstDientes" :key="index">
                <b-td>{{diente.texto}}</b-td>
                <b-td>{{diente.padecimiento.nombre}}</b-td>
                <b-td>
                  <ul v-for="(tratamiento, index) of diente.padecimiento.tratamientos" :key="index">
                      <li>
                        {{tratamiento.nombre}}
                        <tag-promocion  v-if="tratamiento.promocion == null" :tratamiento.sync="tratamiento" :promociones.sync="promociones">
                        </tag-promocion>
                        <p class="letrasChiquitas" v-if="tratamiento.promocion != null">{{ tratamiento.promocion.promocion}}   <em v-if="tratamiento.promocion.promocionForzosa == false" class="fa fa-close botoncito" @click="quitarPromo(tratamiento)"></em> </p>
                      </li>
                   </ul>
                </b-td>
                <td>
                  <ul v-for="(tratamiento, index) of diente.padecimiento.tratamientos" :key="index">
                    <li>
                      1
                    </li>
                  </ul>
                </td>
                <b-td class="text-center">
                  <b-button class="btn-outline-danger" variant="outline-danger" v-on:click="eliminarTratamiento(index)">
                    <b-icon icon="trash"></b-icon>
                  </b-button>
                </b-td>
              </tr>
            </b-tbody>
          </b-table-simple>
          <div align="center" v-if="loaderLstDientes">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <div v-if="lstDientes.length === 0" align="center">
            <b-alert show variant="warning">No hay datos</b-alert>
          </div>
        </b-col>
      </b-row>
      <b-row><b-col><p></p></b-col></b-row>
      <b-row>
        <b-col align="right">
          <b-button variant="outline-primary" v-on:click="guardar()" :disabled="loaderBtngGuardar">
            <span v-if="!loaderBtngGuardar">Guardar</span>
              <span v-else>
                    <b-spinner small></b-spinner>
                  Guardando ...
              </span>
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <b-modal size="lg" ref="modal_tipo" title="Estas por realizar un diagnostico emergente" no-close-on-backdrop no-close-on-esc hide-header-close>
      <b-container fluid>
        <b-row align="center">
          <b-col>
            Selecciona las razones de realizar este presupuesto emergente
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form novalidate>
              <b-form-checkbox-group :options="options" id="razon" v-model="razonPresupuesto.tipo" name="razon_presupuesto" stacked v-on:change="chequeado($event)">
              </b-form-checkbox-group>
              <b-form-group v-if="blnEspecifique" label="Especifique" label-for="espedifique">
                <b-textarea id="espedifique" v-model="razonPresupuesto.especifique"></b-textarea>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label class="texto-rojo">Importante. Este presupuesto emergente tiene validez únicamente en esta sesión</label>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-primary" v-on:click="siguiente()" :disabled="!blnSiguiente">Siguiente</b-button>
        <b-button variant="outline-danger" v-on:click="cancelar()">Cancelar</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import miniToastr from "mini-toastr";
import TagPromocion from "../../components/promocion/TagPromocion";
import {PromocionesService} from "../../apiServices/promociones/PromocionesService";

export default {
  name: "presupuestoEmergente",
  components: {TagPromocion},
  data: ()=> ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    arcada:0,
    cuadrante:0,
    oD2Final:0,
    oDInicio:0,
    dienteDto:null,
    tamanio:1,
    buscarTratamiento:[],
    buscarPadecimiento:null,
    idPadecimiento:null,
    buscarZona:null,
    selectedZona:null,
    detallePaciente:null,
    tratamientos:[
      {idTratamiento:null, nombre:""}
    ],
    lstTratamientos:[],
    lstPadecimientos:[],
    options: [
      { value: 'Dolor', text: 'Dolor' },
      { value: 'Fractura', text: 'Fractura' },
      { value: 'Estetica', text: 'Solicitud del paciente por estetica' },
      { value: 'otro', text: 'Otro' }
    ],
    lstZona:[
      {value: null, text: 'Seleccione una zona', disabled: true},
      {value:1,text:'Por diente'},
      {value:2,text:'Por cuadrante'},
      {value:3,text:'Por arcada'},
      {value:4,text:'Toda la boca'}
    ],
    lstCuadrante:[
      {value: null, text: 'Seleccione un cuadrante', disabled: true},
      {value:1,text:'C1'},
      {value:2,text:'C2'},
      {value:3,text:'C3'},
      {value:4,text:'C4'}
    ],
    lstArcada:[
      {value: null, text: 'Seleccione una arcada', disabled: true},
      {value:1,text:'SUP'},
      {value:2,text:'INF'},
    ],
    lstDientes:[],
    razonPresupuesto:{
      tipo:[],
      especifique:""
    },
    loaderLstDientes:false,
    blnEspecifique:false,
    blnDatosEmergente:false,
    blnSiguiente:false,
    pacienteSeleccionado:10004061771,
    blnLoaderTable:false,
    btnGuardar:false,
    loaderBtngGuardar:false,
    idPti:null,
    nombreDoctor:null,
    adultoNino: "1",
    dientesAdultoArray: [],
    dientesNinoArray: [],
    dientesMixArray: [],
    textoTablaDiente: "",
    promocionesServicio: new PromocionesService(),
    promociones: [],
    loaderConsultarTxDescuento: false,
    loadingPromos: false
  }),
  props:{
    idPaciente:null,
    idClinica:null,
    idSesion:null,
    idEmpleado:null,
    nombreEmpleado:null,
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.nombreDoctor = this.nombreEmpleado;
    this.pacienteSeleccionado = this.idPaciente;
  },
  async mounted() {
    //await this.obtenerPromociones();
    this.abrirModal();
    this.getDientes("dientesAdulto");
    this.getDientes("dientesNino");

  },
  computed:{
    fechaHoy() {
      let fecha = new Date();
      let options = {
        year: "numeric",
        month: "long",
        day: "numeric",
      };

      return fecha.toLocaleDateString("es-MX", options);
    },
  },
  methods:{
    abrirModal(){
      this.$refs['modal_tipo'].show();
    },
    cancelar(){
      this.$refs['modal_tipo'].hide();
      this.$emit('speak', 'cerrar');
    },
    cancelarPresupuesto(){
      this.$refs['modal_tipo'].hide();
    },
    /**
     * Funcion del boton siguiente de la razon
     */
    siguiente: function () {
      if(this.razonPresupuesto.tipo.length !== 0) {
        if (this.blnEspecifique) {
          if(this.razonPresupuesto.especifique.length !== 0){
            this.avanzar();
          }else{
            this.mensajeError("Especifique la razón");
          }
        }else{
          this.avanzar();
        }
      }
      else{
        this.mensajeError("Seleccione la razón");
      }
    },
    /**
     * funcion para visualizar modulo completo
     */
    avanzar(){
      this.blnDatosEmergente = true;
      this.cancelarPresupuesto();
      this.obtenerPaciente();
    },
    /**
     * Cual check le diste click
     * @param evento
     */
    chequeado(evento){
      if(evento.find(item =>{ return  item === 'otro'}) === 'otro'){
        this.blnEspecifique = true;
      }else{
        this.blnEspecifique = false;
      }
      if(evento.length !== 0){
        this.blnSiguiente = true;
      }else{
        this.blnSiguiente = false;
      }
    },
    /**
     * Obtener datos del paciente
     */
    obtenerPaciente(){
      this.blnLoaderTable = true;
      const param = {
        idPaciente: this.pacienteSeleccionado
      }
      this.$http.post(this.$api + "presupuesto/emergente/obtener/paciente", param).then(response => {
        if(response.data.data == null){
          this.mensajeError("Error el paciente no tiene OG de cabecera");
          this.blnDatosEmergente = false
        }
        if (response.data.data){
          let resultado = response.data.data;
          this.detallePaciente = resultado;
          this.blnLoaderTable = false;
          this.idPti = resultado.idPti;
        }
      }).catch(function (error) {
        console.error(error);
        this.mensajeError("Error en el sistema, Intente más tarde");
      });
    },
    /**
     * Funcion para obtener los padecimientos por zona
     */
    obtenerPadecimientosByZona(){
      const params = {
        idZona: this.selectedZona
      }
      this.$http.post(this.$api + "presupuesto/emergente/obtener/padecimientos", params
      ).then(response => {
        if (response.data.data){
          let resultado = response.data.data;
          this.lstPadecimientos=[];
          resultado.forEach((item, index) =>{
            item.id = index;
            this.lstPadecimientos.push(item);
            //this.lstPadecimientos.push({value: item.idPadecimento, text: item.descripcion});
          });
        }
      }).catch(function (error) {
        console.error(error);
        this.mensajeError("Error en el sistema, Intente más tarde");
      });
    },
    /**
     *Funcion para obtener los tratamietos por padecimiento
     **/
    obtenerTratamientosByPadecimiento(){
      const params = {
        idEmpleado: this.idEmpleado,
        idClinica: this.idClinica,
        idPadecimiento: this.idPadecimiento,
      }
      this.$http.post(this.$api + "presupuesto/emergente/obtener/tratamientos/empleado", params 
         ).then(response => {
        if (response.data.data){
          let resultado = response.data.data;
          this.lstTratamientos=[];
          resultado.forEach((item, index) =>{
            item.id = index;
            this.lstTratamientos.push(item);
            //this.lstTratamientos.push({value: item.idTratamiento, text: item.nombre});
          });
        }
      }).catch(function (error) {
        console.error(error);
        this.mensajeError("Error en el sistema, Intente más tarde");
      });
    },
    /**
     * Funcion para seleccionar la zona
     * @param evento
     */
    seleccinarZona(evento){
      this.selectedZona = evento;
      this.obtenerPadecimientosByZona();
    },
    /**
     * Funcion para seleccionar los padecimientos
     * @param evento
     */
    seleccinarPadecimiento(evento){
      this.idPadecimiento = evento.idPadecimento;
      this.obtenerTratamientosByPadecimiento();
    },
    /**
     * Funcion para seleccionar los tratamientos
     * @param evento
     */
    async seleccinarTratamientos(evento, index) {
      this.tratamientos[index].idTratamiento = evento.idTratamiento;
      this.tratamientos[index].idTipoTratamiento = evento.idTipoTratamiento;
      const rep = await this.obtenerDescuentoTratamiento(evento.idTratamiento);
      await this.obtenerPromocionesPorTratamiento(evento.idTratamiento);
      if (rep != null) {
        this.tratamientos[index]["porcentajePlanDescuento"] = rep.descuento;
        this.tratamientos[index]["idTipoPaciente"] = rep.idTipoPaciente;
        this.tratamientos[index]["idSubTipoPaciente"] = rep.idSubTipoPaciente;
      }
      this.loaderConsultarTxDescuento = false;
    },
    /**
     * Funcion para agregar tratamientos
     * @param tratamiento
     */
    agregarTratamiento(){
      this.tratamientos.push({
        idTratamiento:0,
        nombre:""
      });
      this.tamanio = this.tratamientos.length;
    },
    /**
     * Funcion para quitar tratamientos de la lista
     * @param index
     */
    quitarTratamiento(index){
      if(this.tamanio > 1){
        this.tratamientos.splice(index,1);
        this.tamanio = this.tratamientos.length;
      }
    },
    eliminarTratamiento(index){
        this.lstDientes.splice(index,1);
    },

    async obtenerPromociones(){
      this.loadingPromos = true;
      await this.promocionesServicio.obtenerPromocionesPorPx(
          this.$localStorageService.getIdClinica(), this.idSesion)
          .then(respuesta => {
            this.promociones = respuesta
            this.loadingPromos = false;
          })
    },
    async obtenerPromocionesPorTratamiento(idTratatamiento) {
      await this.promocionesServicio.obtenerPromocionesPorPxPorTx(this.$localStorageService.getIdClinica(), this.idSesion, idTratatamiento)
          .then(respuesta => {
            respuesta.forEach(item=>{
              this.promociones.push(item);
            })
          })
    },
    quitarPromo(item){
      this.promociones.forEach( p => {
        if (p.idPromocion === item.promocion.idPromocion){
          p.seleccionado = false;
        }
      })
      item.promocion = null
    },
    /**
     *Funcion para construir json para la tabla
     */
    Agregar(){
      if(this.selectedZona === 1) {
        if((this.oDInicio !== 0 && this.oD2Final !== 0) ||this.cuadrante !== 0 || this.arcada !== 0){
          if(this.buscarPadecimiento){
            this.obtenerListadoDientes();
          }else{
            this.mensajeError("Padecimiento incompleto");
          }
        }else{
          this.mensajeError("Datos de zona incompletos");
        }
      }else if (this.selectedZona === 4 || this.selectedZona === 2 || this.selectedZona === 3){
        if(this.buscarPadecimiento){
          this.obtenerListadoDientes();
        }else{
          this.mensajeError("Padecimiento incompleto");
        }
      }else{
        this.mensajeError("Seleccione una zona");
      }
    },
    obtenerListadoPorZona(numDiente){
      switch (this.selectedZona) {
        case 1:
          return  numDiente;
        case 2:
          return  "Cuadrante: " + this.findingCuadrante(this.cuadrante);
        case 3:
          return  "Arcada: " + this.findingArcada(this.arcada);
        case 4:
          return  "Toda la boca";
        default:
          break;
      }

    },
    findingCuadrante(cuadrante){
     const index = this.lstCuadrante.findIndex(c => c.value === cuadrante);
     return this.lstCuadrante[index].text;
    },
    findingArcada(arcada){
      const index = this.lstArcada.findIndex(c => c.value === arcada);
      return this.lstArcada[index].text;
    },
    /**
     * Funcion para obtener el listado de dientes segun la seleccion de la zona
     */
    obtenerListadoDientes(){
      this.dienteDto = {
        oDInicio:this.oDInicio,
        oD2Final:this.oD2Final,
        cuadrante:this.cuadrante,
        arcada:this.arcada,
        boca:false,
        zona:this.selectedZona,
        ninoAdulto: this.adultoNino
      };
      this.loaderLstDientes = true;
      this.$http.post(this.$api + "presupuesto/emergente/obtener/dientes/zona",this.dienteDto).then(response => {
        this.loaderLstDientes = false
        if (response.data.data){
          let resultado = response.data.data;
          if(resultado.length > 0){
            resultado.forEach(item =>{
              this.buscarPadecimiento.tratamientos = [];
              this.tratamientos.forEach(tratamiento =>{
                tratamiento.nombre["porcentajePlanDescuento"] = tratamiento.porcentajePlanDescuento;
                tratamiento.nombre["idTipoPaciente"] = tratamiento.idTipoPaciente;
                tratamiento.nombre["idSubTipoPaciente"] = tratamiento.idSubTipoPaciente;
                this.buscarPadecimiento.tratamientos.push(tratamiento.nombre);
              });
              this.buscarPadecimiento.tratamientos.forEach(v => { v.promocion = null})
              var data = {
                idDiente: item.idDiente,
                numeroDiente:item.numeroDiente,
                texto: this.obtenerListadoPorZona(item.numeroDiente),
                padecimiento: {
                  nombre:this.buscarPadecimiento.descripcion,
                  tratamientos:this.buscarPadecimiento.tratamientos
                },
                promocion: null
              };

              var tratamientoExistente = this.lstDientes.find(t => {
                return JSON.stringify(t) === JSON.stringify(data);
              });
              if(tratamientoExistente === undefined){
                this.lstDientes.push(data);
              } else {
                miniToastr.warn("El tratamiento ya esta asignado");
              }


            });
            this.btnGuardar = true;
          }
        }
      }).catch(function (error) {
        this.loaderLstDientes = false;
        this.btnGuardar = false;
        console.error(error);
        this.mensajeError("Error en el sistema, Intente más tarde");
      });
    },
    /**
     * FUNCION PARA GURDAR LOS TRATAMIENTOS PROGRAMADOS EMERGENTES
     */
    guardar(){
      this.loaderBtngGuardar = true;
      if(this.idEmpleado === undefined){
        this.idEmpleado = this.detallePaciente.idEmpleado;
      }
      let objeto ={
        idEmpleado: this.idEmpleado,
        idClinica: this.idClinica,
        idCompania: 1,
        idPaciente: this.idPaciente,
        emergencia: true,
        idUsuario:this.$localStorageService.getIdUsuario(),
        tipoEmergencia:this.razonPresupuesto.tipo,
        especifiqueEmergencia:this.razonPresupuesto.especifique,
        tratamientos:this.lstDientes
      };
      this.$http.post(this.$api + "presupuesto/emergente/guardar", objeto).then(response => {
        this.loaderBtngGuardar = false;
        if (response.data.data) {
          let resultado = response.data.success;
          if (resultado) {
            this.mensajeExito("Datos guardados con éxito");
            this.cerrar();
          }
          this.$root.$emit('refresh');
        }
      }).catch(function (error) {
        this.loaderBtngGuardar = false;
        this.loaderLstDientes = false;
        console.error('Error: ', error);
        this.mensajeError("Error en el sistema, Intente más tarde");
      }).finally(()=>{
        this.$emit('refresh-tratamemientos')
        this.$root.$emit('bv::hide::modal', 'agregarTratamientos', '#btnShow');
      });
    },
    /**
     * Funcion para limpiar tabla de tratamientos
     */
    Limpiar(){
      this.lstDientes = [];
    },
    /**
     * Funcion para mostrar alert
     * @param mensaje
     */
    mensajeError(mensaje){
      this.$swal({
        icon: "error",
        text: mensaje,
        confirmButtonText: "OK",
        confirmButtonColor: "#0e6ba9",
      });
    },
    /**
     * Funcion para mostrar alert
     * @param mensaje
     */
    mensajeExito(mensaje){
      this.$swal({
        icon: "success",
        title: mensaje,
        confirmButtonText: "OK",
        confirmButtonColor: "#0e6ba9",
      });
    },
    /**
     * Funcion para cerrar
     */
    cerrar(){
      this.$refs['modal_tipo'].hide();
      this.$emit('speak', 'cerrar');
    },

    getDientes(tipo) {
      var url = "ptipresuntivo/obtener/catalogo/dientes";

      const params = {
        adulto: tipo == "dientesAdulto" ? true : false, 
        ninio: tipo == "dientesAdulto" ? false : true,
      }
      this.$http
          .post(this.$api + url, params)
          .then((response) => {
            if (Array.isArray(response.data.data) == true) {
              if (tipo == "dientesAdulto") {
                this.dientesAdultoArray = response.data.data.map(function (item) {
                  var data = {
                    text: item.numeroDiente,
                    value: item.numeroDiente,
                  };
                  return data;
                });
                /*this.dientesAdultoArray.push({text: "Ninguno", value: null});*/
              } else {
                this.dientesNinoArray = response.data.data.map(function (item) {
                  var data = {
                    text: item.numeroDiente,
                    value: item.numeroDiente,
                  };
                  return data;
                });
                /*this.dientesNinoArray.push({text: "Ninguno", value: null});*/
              }
              this.dientesMixArray = JSON.parse(
                  JSON.stringify(
                      this.dientesNinoArray.concat(this.dientesAdultoArray)
                  )
              );
              this.dientesMixArray = this.dientesMixArray.filter(
                  (itm) => itm.value != null
              );
              /*this.dientesMixArray.push({text: "Ninguno", value: null});*/
            }
          })
          .catch(function (error) {
            console.error(error);
          });
    },
    async obtenerDescuentoTratamiento(idTx) {
      this.loaderConsultarTxDescuento = true;
      const parametros = {
        idClinica: this.idClinica,
        idPaciente: this.idPaciente,
        idTratamiento: idTx
      }
      return await this.$http
          .post(
              this.$api +
              "presupuesto/emergente/consultar",
              parametros
          )
          .then((response) => {
            return response.data.data;
          })
          .catch(function () {
            //this.loaderDoctores = false;
          })
    }
  }
}
</script>

<style scoped>

.centerDiv {
  display: flex;
  justify-content: center;
}

.flxButons {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 30%;
  margin-bottom: 10px;
}

.btn-outline-danger {
  color: #dc3545 !important;
  border-color: #dc3545 !important;
}

.btn-outline-danger:hover {
  color: white !important;
  background-color: #dc3545 !important;
}
.letrasChiquitas {
  padding: 0px;
  font-size: x-small;
  color: lightslategray;
  text-align: right;
}
.botoncito {
  cursor: pointer;
  color: #0d0d0d;
}

.botoncito:hover {
  color: red;
}


</style>
